import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        getAllIntent: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllIntent`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getIntentById: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getIntentById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateIntent: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateIntent`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addIntent: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/addIntent`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllFlow: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllFlow`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getFlowById: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getFlowById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateFlow: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateFlow`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addFlow: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/addFlow`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getFlowByIntentId: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getFlowByIntentId`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addStep: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/addStep`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateStep: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateStep`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllSteps: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllSteps`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getStepById: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getStepById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getStepByFlowId: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getStepsByFlowId`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getActiveIntent: builder.query({
            query: () => ({
                url: 'knowledgeBase/getAllActiveIntent'
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),
        addOption: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/addOption`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateOption: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateOption`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllOptions: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllOptions`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getOptionById: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getOptionById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

    })
})

export const { useGetAllIntentMutation, useUpdateIntentMutation, useGetIntentByIdMutation, useAddIntentMutation, useGetActiveIntentQuery,
    useAddFlowMutation, useGetAllFlowMutation, useGetFlowByIdMutation, useUpdateFlowMutation,
    useGetFlowByIntentIdMutation, useAddStepMutation, useUpdateStepMutation, useGetAllStepsMutation, useGetStepByIdMutation,
    useGetStepByFlowIdMutation, useAddOptionMutation, useUpdateOptionMutation, useGetAllOptionsMutation, useGetOptionByIdMutation
} = Api
